import { connect } from 'react-redux';
import PaymentsHistoryList, { PAYMENTS_HISTORY_MODE } from "./PaymentsHistoryList";
import { getTranslation } from "../../../../reducers/common/localization";
import {
    fetchGetPaymentsHistoryForBAs,
    loadingBAsPaymentsHistory,
    getBAsPaymentsHistoryData,
    getDateFromFilterForBAsPaymentsHistory,
    getDateToFilterForBAsPaymentsHistory,
    getNameFilterForBAsPaymentsHistory,
    updateDateFromFilterForBAsPaymentsHistory,
    updateDateToFilterForBAsPaymentsHistory,
    updateNameFilterForBAsPaymentsHistory,
    onUpdateCountryFilterByContinentForBAsPaymentsHistory,
    onUpdateCountryFilterForBAsPaymentsHistory
} from '../../../../reducers/systemPayments/paymentsHistory';
import {MODAL_PAYMENT_HISTORY_COMMENT, showModal} from '../../../../reducers/common/activeModal';
import {getLocationData} from '../../../../reducers/common/location';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        mode: PAYMENTS_HISTORY_MODE.BA,
        loading: loadingBAsPaymentsHistory(state),
        data: getBAsPaymentsHistoryData(state),
        dateFromFilter: getDateFromFilterForBAsPaymentsHistory(state),
        dateToFilter: getDateToFilterForBAsPaymentsHistory(state),
        nameFilter: getNameFilterForBAsPaymentsHistory(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetPaymentsHistoryForBAs());
        },
        onChangeDateFromFilter: (dateFrom) => {
            dispatch(updateDateFromFilterForBAsPaymentsHistory(dateFrom));
        },
        onChangeDateToFilter: (dateTo) => {
            dispatch(updateDateToFilterForBAsPaymentsHistory(dateTo));
        },
        onChangeNameFilter: (name) => {
            dispatch(updateNameFilterForBAsPaymentsHistory(name));
        },
        onShowComment: () => {
            dispatch(showModal({modalKey: MODAL_PAYMENT_HISTORY_COMMENT}));
        },
        onChangeContinentFilter: (continent) => {
            dispatch(onUpdateCountryFilterByContinentForBAsPaymentsHistory(continent));
        },
        onChangeCountryFilter: (country) => {
            dispatch(onUpdateCountryFilterForBAsPaymentsHistory(country));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsHistoryList);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/paymentsHistoryList/BAsPaymentsHistoryList.container.js